(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[269],{

/***/ "cKQV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/product-program/ProductProgram.jsx
var ProductProgram = __webpack_require__("TF5j");

// CONCATENATED MODULE: ./src/client/components/lines/tour-program-line/TourProgramLine.jsx

var __jsx = react_default.a.createElement;



var TourProgramLine_TourProgramLine = function TourProgramLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  var _props$stopover = props.stopover,
      stopover = _props$stopover === void 0 ? {} : _props$stopover;
  var _stopover$tour = stopover.tour,
      tour = _stopover$tour === void 0 ? {} : _stopover$tour,
      _stopover$extension = stopover.extension,
      extension = _stopover$extension === void 0 ? {} : _stopover$extension;
  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, __jsx(ProductProgram["a" /* ProductProgram */], {
    isDetailed: props.isDetailed,
    extension: {
      stops: extension.stops,
      subtitle: extension.duration,
      title: extension.title
    },
    program: {
      stops: tour.stops,
      subtitle: tour.duration,
      title: tour.title
    }
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/tour-program/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (TourProgramLine_TourProgramLine);

/***/ })

}]);